export const NUM_OF_GUESSES_ALLOWED = 6;
export const WORD_SIZE = 5; // NOTE: Need to change data and CSS html variable to match
export const FLIP_LETTER_SPEED = 500; // In ms
export const TIME_TO_FINISH_FLIPS = FLIP_LETTER_SPEED * (WORD_SIZE + 1);
